let gk_highlights = {
  load() {
    const blocks = document.querySelectorAll(".HighLightsBlock");
    if (!blocks.length) return;

    // ── Counter animation ─────────────────────────────────────────────────────
    const animateCounter = (el) => {
      const countTo = Number(el.dataset.count || 0);
      const duration = 1500;
      const startTime = performance.now();

      const update = (now) => {
        const raw = (now - startTime) / duration;
        const progress = Math.max(0, Math.min(raw, 1));
        const value = Math.max(0, Math.floor(progress * countTo));
        el.textContent = value;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          el.textContent = countTo;
        }
      };

      requestAnimationFrame(update);
    };

    // ── Gauge animation (modes gauge / gauge_marker) ──────────────────────────
    const animateGauge = (barEl) => {
      const keyNumber = barEl.closest(".HighLights-keyNumber");
      const numberEl  = keyNumber
        ? keyNumber.querySelector(".HighLights-number")
        : null;
      const count  = parseFloat(numberEl?.dataset.count || 0);
      const max    = parseFloat(barEl.dataset.max || 100);
      const target = Math.round(Math.min(count / max, 1) * 100);

      const marker = barEl.querySelector(".HighLights-gaugeMarker");

      // rAF requis : le navigateur doit avoir rendu --gauge-progress: 0
      // avant de passer à la valeur cible pour déclencher la transition Houdini
      requestAnimationFrame(() => {
        barEl.style.setProperty("--gauge-progress", String(target));
        if (marker) marker.style.setProperty("--gauge-progress", String(target));
      });
    };

    // ── Reset DOM ready (D11) ─────────────────────────────────────────────────
    // Évite le flash valeur-Twig → 0 au premier scroll.
    blocks.forEach((block) => {
      block.querySelectorAll(".HighLights-number").forEach((el) => {
        el.textContent = 0;
      });
      block.querySelectorAll(".HighLights-gaugeBar").forEach((barEl) => {
        barEl.style.setProperty("--gauge-progress", "0");
        const marker = barEl.querySelector(".HighLights-gaugeMarker");
        if (marker) marker.style.setProperty("--gauge-progress", "0");
      });
    });

    // ── IntersectionObserver ──────────────────────────────────────────────────
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);

          entry.target.querySelectorAll(".HighLights-number").forEach((el) => {
            animateCounter(el);
          });

          entry.target.querySelectorAll(".HighLights-gaugeBar").forEach((barEl) => {
            animateGauge(barEl);
          });

          entry.target.querySelectorAll(".HighLights-skillbars").forEach((el) => {
            el.classList.add("is-visible");
          });
        });
      },
      { threshold: 0.4 },
    );

    blocks.forEach((block) => observer.observe(block));
  },
};

export default gk_highlights;
